__turbopack_context__.v({
  "banner": "message-bar-module__duX6Lq__banner",
  "hasDetails": "message-bar-module__duX6Lq__hasDetails",
  "info": "message-bar-module__duX6Lq__info",
  "messageBar": "message-bar-module__duX6Lq__messageBar",
  "messageBarBody": "message-bar-module__duX6Lq__messageBarBody",
  "messageBarDetails": "message-bar-module__duX6Lq__messageBarDetails",
  "messageBarEnd": "message-bar-module__duX6Lq__messageBarEnd",
  "messageBarIcon": "message-bar-module__duX6Lq__messageBarIcon",
  "messageBarStart": "message-bar-module__duX6Lq__messageBarStart",
  "messageBarText": "message-bar-module__duX6Lq__messageBarText",
  "negative": "message-bar-module__duX6Lq__negative",
  "note": "message-bar-module__duX6Lq__note",
  "reserveActionSpace": "message-bar-module__duX6Lq__reserveActionSpace",
  "wideNote": "message-bar-module__duX6Lq__wideNote",
});
